import React, { useState, useEffect, memo } from "react";
import img from "components/a.png";

const KeyboardCheck = memo( function KeyboardCheck({ setNextFlag }) {

	useEffect(() => {
		setNextFlag(true);
	}, []);
	
	return (
		<div className="col-xs-12 successContent mock-resource-text">
			<div className="col-lg-12">
				<h4 className="mt-0">Keyboard Check</h4>
				<h6>This is an opportunity to check that you have the correct keyboard.</h6>
				<div className="col-xs-12">
					<ol  style={{ listStyle: "auto" }}>
						<li>Look at the top row of letters on the keyboard.</li>
						<li>The letters should appear in this order Q W E R T Y.</li>
						<li>If you do not have a QWERTY keyboard, raise your hand to get the attention of the Test Administrator</li>
					</ol>
					<div className="keyboardImg">
						<img src={img} alt="keyboard" />
					</div>
				</div>
			</div>
		</div>
	);
});

export default KeyboardCheck;